import useLocalStore from '../../../hooks/useLocalStore.js';
import { useDispatch, useSelector } from 'react-redux';
import FJModal from '../FJModal';
import FJDiscountView from './FJDiscountView.jsx';
import FJActionModal from '../../../redux/action/FJActionModal.js';
import { setTimeDiscountSelectedIndex } from '../../../redux/slices/FJSliceModals.js';
import FJActionCommon from '../../../redux/action/FJActionCommon.js';

const FJTimeDiscountPanel = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const timeDiscountPanelData = useSelector(state => state.modals.timeDiscountPanelData);
    const timeDiscountSelectedIndex = useSelector(state => state.modals.timeDiscountSelectedIndex);
    const currentCountryMonetary = useSelector(state => state.common.currentCountryMonetary);
    const currentCountryMonetaryISO = useSelector(state => state.common.currentCountryMonetaryISO);
    const exchangeRate = useSelector(state => state.common.exchangeRate);
    const couponData = useSelector(state => state.common.couponData);

    const { visible } = timeDiscountPanelData;

    const _onClose = () => {
        dispatch(FJActionModal.setTimeDiscountPanelDataAction(false));
        // TODO 隐藏升级弹窗
        dispatch(FJActionModal.hideUpgradeModalAction());
    };

    const _onSelect = index => {
        dispatch(setTimeDiscountSelectedIndex(index));
    };

    const _onUpgrade = coupon => {
        if (window.openSubscribeWithCoupon) {
            window.openSubscribeWithCoupon({ index: timeDiscountSelectedIndex, coupon: coupon }, true);
            dispatch(FJActionCommon.getCreditsAction());
            _onClose();
        }
    };

    return (
        <FJModal
            visible={visible}
            zIndex={1005}
            backgroundColor='transparent'
            boxShadow='none'
            maskStyle={{ backdropFilter: `blur(10px)` }}
        >
            <FJDiscountView
                exchangeRate={exchangeRate}
                currentCountryMonetary={currentCountryMonetary}
                currentCountryMonetaryISO={currentCountryMonetaryISO}
                data={couponData}
                selectedIndex={timeDiscountSelectedIndex}
                onSelect={_onSelect}
                onClose={_onClose}
                onUpgrade={_onUpgrade}
            />
        </FJModal>
    );
};

export default FJTimeDiscountPanel;
